export const UNKNOWN_ID = '000000000000000000000000';

export const UNKNOWN_VALUE = '[unknown]';

export const UNKNOWN_URL = 'url:unknown';
